import React from "react";

import { motion } from "framer-motion";
import { pageAnimation, titleAnim } from "../animation";
import styled from "styled-components";
const ContactUs = () => {
  return (
    <ContactStyle
      variants={pageAnimation}
      initial="hidden"
      animate="show"
      style={{
        background: "white",
      }}
    >
      <Title>
        <Hide>
          <motion.h2 variants={titleAnim}>Get in Touch</motion.h2>
        </Hide>
      </Title>
      <div>
        <Social variants={titleAnim}>
          <h2>Send Us a Message ?</h2>
        </Social>
      </div>
      <div>
        <Social variants={titleAnim}>
          <h2>Drop Us a Email</h2>
        </Social>
      </div>
      <div>
        <Social variants={titleAnim}>
          <h2>Call us</h2>
        </Social>
      </div>
    </ContactStyle>
  );
};

const ContactStyle = styled(motion.div)`
  padding: 5rem 10rem;
  color: #353535;
  min-height: 90vh;
`;

const Title = styled.div`
  margin-bottom: 4rem;
  color: black;
`;

const Hide = styled.div`
  overflow: hidden;
`;

const Circle = styled.div`
  border-radius: 50%;
  width: 2rem;
  height: 2rem;
  background: #353535;
`;

const Social = styled(motion.div)`
  display: flex;
  align-items: center;
  margin-bottom: 1.5rem;
  h2 {
    font-size: 1.5rem;
    background-color: #bebebe;
    padding: 0.5rem 1rem;
    border-radius: 40px;
    width: 300px;
    text-align: center;
  }
`;

export default ContactUs;
